// extracted by mini-css-extract-plugin
module.exports = {"patientPanel":"PatientPanel_patientPanel__17mAJ","title":"PatientPanel_title__3uibW","divider":"PatientPanel_divider__vqbpx"};